import {EventEmitter, Injectable} from '@angular/core';
import {BaseModalComponent} from './base-modal.component';
import {map, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {NgbActiveModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

export type ModalAction = 'Close' | 'add' | 'edit' | 'remove' | 'ok' | 'save' | 'delete' | string;

@Injectable({
  providedIn: 'root'
})
export class LeModalRef<T extends BaseModalComponent> {
  /**
   * Reference to a component inside the modal. Null if modal's been created with TemplateRef
   */
  content = this.modalRef.componentInstance as T;

  /**
   * Hides the modal
   */
  hide(result?: any) {
    this.modalRef.close(result);
  }

  onHide$: Observable<{ content: T, data: any, result?: string }>;
  action: EventEmitter<{ action: ModalAction, data: any, modal?: NgbActiveModal, content?: T }> = new EventEmitter<{ action: ModalAction, data: any, modal?: NgbActiveModal, content?: T }>();

  constructor(private modalRef: NgbModalRef) {
    this.onHide$ = this.content.onHide$.pipe(map(({data, action}) => {
      return {
        content: this.content,
        data: data,
        result: action
      } as { content: T, data: any, action?: string };
    }));
    this.content.action.subscribe(x => this.action.emit({modal: x?.modal, action: x?.action, data: x?.data, content: this.content}));
  }
}
